import setDeleteRequests from './setDeleteRequests';
import setDeleteRequest from './setDeleteRequest';
import resetCurrentDeleteRequest from './resetCurrentDeleteRequest';

export default {
  setDeleteRequests,
  setDeleteRequest,
  resetCurrentDeleteRequest,
};
